import React from "react";
import { FileText, Download } from "lucide-react";
import "./Downloads.css";
import NavBar from "./NavBar";
import Footer from "./Footer";

const pdfs = [
  {
    title: "Project Finance 101: What Makes a Project Bankable",
    description: "Foundational guide to evaluating project finance readiness.",
    file: "Project Finance 101_wHAT mAKES A PROJECT bANKABLE.pdf",
  },
  {
    title: "A Practical Guide to Trade Finance",
    description: "Practical overview of trade finance instruments and flows.",
    file: "A Practical Guide to Trade Finance.pdf",
  },
];

function Downloads() {
  return (
    <section className="downloads-section">
      <NavBar />
      <div className="downloads-container">
        <div className="downloads-header">
          <h2>
            Downloads <span className="accent">Library</span>
          </h2>
          <p>Browse and download our latest PDF resources.</p>
        </div>

        <div className="downloads-grid">
          {pdfs.map((pdf) => (
            <div className="download-card" key={pdf.file}>
              <div className="download-card-head">
                <div className="download-icon">
                  <FileText size={22} />
                </div>
                <div className="download-meta">
                  <h4>{pdf.title}</h4>
                  <p>{pdf.description}</p>
                </div>
              </div>

              <div className="download-card-footer">
                <span className="download-type">PDF</span>
                <a
                  className="download-btn"
                  href={`/pdfs/${encodeURIComponent(pdf.file)}`}
                  download
                >
                  <Download size={18} />
                  Download
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </section>
  );
}

export default Downloads;
